<div class="plc-container">
  <div class="plc-header">
    <div class="plc-header-left">
      <i class="fas fa-map-pin mg-r-5"></i>
      <span>{{ title() }}</span>
    </div>
    <span class="plc-badge">{{ plcList()?.length || 0 }}</span>
  </div>

  <div class="plc-search-bar">
    <dx-text-box
      class="plc-search"
      mode="search"
      placeholder="Recherche"
      (onValueChanged)="onSearchChanged($event)">
    </dx-text-box>

    <yo-button
      tooltip="Ajouter un point de livraison"
      class="mg-l-5"
      iconClass="fas fa-plus"
      [theme]="ButtonThemeEnum.ADD"
      (onClick)="openAddDialog()">
    </yo-button>

    <yo-button
      tooltip="Supprimer un point de livraison"
      class="mg-l-5"
      [theme]="ButtonThemeEnum.DELETE"
      iconClass="fas fa-trash"
      (onClick)="openRemoveDialog()"
      [disabled]="!plcList()?.length">
    </yo-button>

  </div>

  <dx-list
    [dataSource]="plcList()"
    keyExpr="id"
    [selectedItemKeys]="[selectedPlcId()]"
    selectionMode="single"
    [searchExpr]="'libelle'"
    [searchValue]="searchValue()"
    [height]="'100%'"
    (onSelectionChanged)="onSelectionChanged($event)">
    <div *dxTemplate="let plc of 'item'">
      <div class="plc-item">
        <i class="fas fa-map-pin mg-r-5 plc-item-icon"></i>
        <span>{{ plc.libelle }}</span>
      </div>
    </div>
  </dx-list>
</div>

<!--DIALOG AJOUT-->
<yo-dialog-ajout-plc
  [(displayAddDialog)]="displayAddDialog"
  [plcList]="plcList()"
  [plcToAddList]="plcToAddList()"
  [contratMenuConvive]="contratMenuConvive()"
  (plcListChange)="onPlcListChange.emit($event)">
</yo-dialog-ajout-plc>

<!--DIALOG SUPPRESSION-->
<yo-dialog-delete-plc
  [(displayRemoveDialog)]="displayRemoveDialog"
  [plcList]="plcList()"
  [plcToRemoveList]="plcToRemoveList()"
  [contratMenuConvive]="contratMenuConvive()"
  (plcListChange)="onPlcListChange.emit($event)">
</yo-dialog-delete-plc>
